import React from "react";

const Loader = () => {
  return (
    <div class="flex flex-col justify-center items-center min-h=[200px] my-10">
      <div class="animate-spin bg-[color:var(--purple-color)] w-14 h-14  rounded-lg"></div>
      <p className="mt-4 text-xl font-semibold">Loading...</p>
    </div>
  );
};

export default Loader;
